import {usePage} from "@inertiajs/vue3";

export default function() {

    const orgs = usePage().props.auth.teams.current?.organizations.filter(org => {
        return org.id === usePage().props.auth.teams.current.current_organization_id;
    });
    if (!orgs?.length) return null;

    return orgs[0];
}
